import { Injectable, signal } from '@angular/core';

export type UiLightboxKind = 'image' | 'pdf';

export interface UiLightboxItem {
  src: string;
  caption?: string;
  alt?: string;
  kind?: UiLightboxKind;
  mimeType?: string;
}

export function resolveLightboxKind(item: UiLightboxItem): UiLightboxKind {
  if (item.kind) return item.kind;
  const mime = String(item.mimeType || '').toLowerCase();
  if (mime === 'application/pdf') return 'pdf';
  const ref = `${item.caption || ''} ${item.src || ''}`.toLowerCase();
  if (/\.pdf(\?|#|$)/i.test(ref)) return 'pdf';
  return 'image';
}

export interface UiLightboxState {
  open: boolean;
  items: UiLightboxItem[];
  index: number;
}

@Injectable({ providedIn: 'root' })
export class UiLightboxService {
  readonly state = signal<UiLightboxState>({ open: false, items: [], index: 0 });

  open(items: UiLightboxItem[], index = 0): void {
    const list = (items || []).filter(i => !!i?.src);
    if (!list.length) return;
    const safeIndex = Math.max(0, Math.min(index, list.length - 1));
    this.state.set({ open: true, items: list, index: safeIndex });
  }

  close(): void {
    const cur = this.state();
    if (!cur.open) return;
    this.state.set({ ...cur, open: false });
  }

  next(): void {
    const cur = this.state();
    if (!cur.open || !cur.items.length) return;
    this.state.set({ ...cur, index: (cur.index + 1) % cur.items.length });
  }

  prev(): void {
    const cur = this.state();
    if (!cur.open || !cur.items.length) return;
    this.state.set({
      ...cur,
      index: (cur.index - 1 + cur.items.length) % cur.items.length,
    });
  }
}
